import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const Campaigns = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_CAMPAIGNS_STATISTICS] : (_,action)=>action.status
})

export default Campaigns
